export default __webpack_public_path__ + "efe0f3615dd88181210cc9259c5ebc04.png";